import QUESTION_TYPE from '@v4/constants/quiz'
import { array, number, string } from 'yup'
import { getWording } from '@v4/utils/wordings'

const getRequiredOptionMessage = () => getWording('warningRequiredOption')

const arraySchema = ({ min, max }, length) => {
	const minValue = Math.min(min, length)
	const maxValue = Math.min(max, length)
	const minOptionMessage = () => getWording('validationMinValueOption', { count: minValue })
	const maxOptionMessage = () => getWording('validationMaxValueOption', { count: maxValue })

	return array()
		.min(minValue, minOptionMessage)
		.max(maxValue, maxOptionMessage)
		.required(getRequiredOptionMessage)
}

const optionSchema = ({ min = 0 }) =>
	number()
		.nullable()
		.min(min, getRequiredOptionMessage)
		.required(getRequiredOptionMessage)

export const textSchema = ({ max, required }) => {
	const maxLengthMessage = () => getWording('validationMaxLength', { count: max })

	const textRequiredMessage = () => getWording('validationRequiredText')

	let validate = string(max, maxLengthMessage)
	if (required) {
		validate = validate.required(textRequiredMessage)
	}
	return validate
}

export const numberSchema = ({ min, max, required, allowDecimals }) => {
	const minMessage = () => getWording('validationMinNumber', { count: min })
	const maxMessage = () => getWording('validationMaxNumber', { count: max })
	const requiredMessage = () => getWording('validationRequiredNumber')
	const integerMessage = () => getWording('validationIntegerNumber')

	let schema = number().transform((value, originalValue) => (originalValue === '' ? undefined : value))

	if (!allowDecimals) {
		schema = schema.integer(integerMessage)
	}

	if (required) {
		schema = schema.required(requiredMessage)
	}

	if (typeof min === 'number') {
		schema = schema.min(min, minMessage)
	}

	if (typeof max === 'number') {
		schema = schema.max(max, maxMessage)
	}

	return schema
}

const validation = {
	[QUESTION_TYPE.BUTTON]: optionSchema,
	[QUESTION_TYPE.MULTI_BUTTON]: arraySchema,
	[QUESTION_TYPE.MULTI_RADIO]: arraySchema,
	[QUESTION_TYPE.RADIO]: optionSchema,
	[QUESTION_TYPE.DIVIDED_SCALE]: optionSchema,
	[QUESTION_TYPE.CHECKBOX]: arraySchema,
	[QUESTION_TYPE.SLIDER]: optionSchema,
	[QUESTION_TYPE.TEXT]: textSchema,
	[QUESTION_TYPE.NUMERIC]: numberSchema,
	[QUESTION_TYPE.MULTI_IMAGE_BUTTON]: arraySchema,
	[QUESTION_TYPE.MULTI_IMAGE_CHECKBOX]: arraySchema,
	default: 'Unsupported',
}

export default validation
